import { StyledAccordionRoot, StyledAccordionItem } from './Accordion.styled';
import { AccordionProps, AccordionTypes } from './types';

export const Accordion = ({
  children,
  accordionType = AccordionTypes.Default,
  ...props
}: AccordionProps) => (
  <StyledAccordionRoot $type={accordionType} {...props} collapsible type="single">
    <StyledAccordionItem value="item-1">{children}</StyledAccordionItem>
  </StyledAccordionRoot>
);
